/**
 * Shared state data
 * -----------------------------------------------------------------------------
 *
 * @namespace store
 */

var store = {
  // Elements via data attributes
  selectors: {
    sitePreloader: '[data-site-preloader]',
    productObj: '[data-product-json]',
    productSubObj: '[data-sub-product-json]',
    siteOverlay: '[data-site-overlay]',
    siteHeader: '[data-site-header]',
    headerSlider: '[data-header-slider]',
    searchLayer: '[data-search-layer]',
    newsletterPopup: '[data-newsletter-popup]',
    carousel: '[data-flickity]',
    productToolbarMobile: '[data-product-toolbar-mobile]',
    productTabs: '[data-product-tabs]',
    accountTabs: '[data-account-tabs]',
    singleOptionSelector: '[data-single-option-selector]',
    qtyContainer: '[data-qty-container]',
    qtyInput: '[data-qty-input]',
    cartItem: '[data-cart-item]',
    productForm: '[data-product-form]',
    cartForm: '[data-cart-form]',
    loginForm: '[data-login-form]',
    recoverForm: '[data-recover-form]',
    passwordInput: '[data-password-input]',
    imageZoom: '[data-img-zoom]'
  },

  isSpinnerVisible: false,

  // Global objects
  currentTemplate: null,
  isLoading: false,
  moneyFormat: window.theme.moneyFormat,
  colorSwatchesEnabled: window.theme.colorSwatchesEnabled,
  sizeSwatchesEnabled: window.theme.sizeSwatchesEnabled,
  productExcludeTag: window.theme.productExcludeTag,

  // ReCharge Integration
  reChargeDiscountVariantId: null,

  // Model
  selectedYear: '',
  selectedMake: '',
  selectedModel: '',
  selectedSubModel: '',
  selectedOption: '',
  selectedbaseVehicle: '',
  selectedRecID: '',
  selectedMaterialID: '',
  selectedMaterialName: '',
  selectedMaterialNameUltimate: '',
  shipDays: '',
  getYearJson: [],
  getMakeJson: [],
  getModelJson: [],
  getSubModelJson: [],
  getOptionJson: [],
  getCartPrice: '',
  mainAddToCartID: '',
  cookieSelectedVehicle: '',
  cookieSelectedVehicleDisplay: '',
  cookieSelectedVehicleURL: '',
  allMaterials: '',
  getUniversalDesign: [],
  getUniversalCategory: [],
  getUniversalResourse: [],
  searchTemplate: [],
  allInstallationVideos: [],
  allInstallationVideosMake: [],
  allInstallationVideosModel: [],
  selectedVideoMake: '',
  selectedVideoMakeSRC: '',
  selectedVideoModel: '',
  selectedUniversalDesign: '',
  selectedUniversalCategory: '',
  selectedUniversalResourse: '',
  selectedURLVideo: '',
  lastName: '',
  zipNumber: '',
  serialNo: '',
  orderNo: '',
  searchText: '',
  currentVariantUniversalID: '',
  currentVariantUniversalTitle: '',

  allScript: {},
  itemIDCart: '',

  // Login
  loginHelper: {
    settings: {
      type: 'default',
      enable: window.theme.loginHelper.enable,
      account_not_found: window.theme.loginHelper.account_not_found,
      account_enable: window.theme.loginHelper.account_enable,
      account_disable: window.theme.loginHelper.account_disable,
      account_invited: window.theme.loginHelper.account_invited,
      account_declined: window.theme.loginHelper.account_declined
    },
    status: null,
    message: null,
    customerEmail: '',
    isLoginFormVisible: true
  }
};

export default store;